module.exports = "/images/cover-5.jpg";